"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TechnicalAladinErrorType = void 0;
exports.unknown = unknown;
exports.unauthorized = unauthorized;
exports.forbidden = forbidden;
exports.validation = validation;
const error_1 = require("./error");
var TechnicalAladinErrorType;
(function (TechnicalAladinErrorType) {
    TechnicalAladinErrorType["UNKNOWN"] = "technical.unknown";
    TechnicalAladinErrorType["UNAUTHORIZED"] = "technical.unauthorized";
    TechnicalAladinErrorType["FORBIDDEN"] = "technical.forbidden";
    TechnicalAladinErrorType["VALIDATION"] = "technical.validation";
})(TechnicalAladinErrorType || (exports.TechnicalAladinErrorType = TechnicalAladinErrorType = {}));
function unknown(message = 'Unknown Error', reasons) {
    return new error_1.AladinError({
        key: TechnicalAladinErrorType.UNKNOWN,
        message,
        details: reasons ? { reasons } : undefined
    });
}
function unauthorized(message = 'Client not authenticated') {
    return new error_1.AladinError({
        key: TechnicalAladinErrorType.UNAUTHORIZED,
        message
    });
}
function forbidden(message = 'Client is missing permissions') {
    return new error_1.AladinError({
        key: TechnicalAladinErrorType.FORBIDDEN,
        message
    });
}
function validation(param1, param2) {
    let message = 'Validation Error';
    let reasons = [];
    if (typeof param1 === 'string') {
        message = param1;
    }
    if (param2 !== undefined) {
        reasons = param2;
    }
    return new error_1.AladinError({
        key: TechnicalAladinErrorType.VALIDATION,
        message,
        details: {
            reasons
        }
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVscGVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9oZWxwZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQVNBLDBCQU1DO0FBRUQsb0NBS0M7QUFDRCw4QkFLQztBQUlELGdDQWdCQztBQWhERCxtQ0FBcUM7QUFFckMsSUFBWSx3QkFLWDtBQUxELFdBQVksd0JBQXdCO0lBQ2xDLHlEQUE2QixDQUFBO0lBQzdCLG1FQUF1QyxDQUFBO0lBQ3ZDLDZEQUFpQyxDQUFBO0lBQ2pDLCtEQUFtQyxDQUFBO0FBQ3JDLENBQUMsRUFMVyx3QkFBd0Isd0NBQXhCLHdCQUF3QixRQUtuQztBQUVELFNBQWdCLE9BQU8sQ0FBQyxPQUFPLEdBQUcsZUFBZSxFQUFFLE9BQWlCO0lBQ2xFLE9BQU8sSUFBSSxtQkFBVyxDQUFDO1FBQ3JCLEdBQUcsRUFBRSx3QkFBd0IsQ0FBQyxPQUFPO1FBQ3JDLE9BQU87UUFDUCxPQUFPLEVBQUUsT0FBTyxDQUFDLENBQUMsQ0FBQyxFQUFFLE9BQU8sRUFBRSxDQUFDLENBQUMsQ0FBQyxTQUFTO0tBQzNDLENBQUMsQ0FBQTtBQUNKLENBQUM7QUFFRCxTQUFnQixZQUFZLENBQUMsT0FBTyxHQUFHLDBCQUEwQjtJQUMvRCxPQUFPLElBQUksbUJBQVcsQ0FBQztRQUNyQixHQUFHLEVBQUUsd0JBQXdCLENBQUMsWUFBWTtRQUMxQyxPQUFPO0tBQ1IsQ0FBQyxDQUFBO0FBQ0osQ0FBQztBQUNELFNBQWdCLFNBQVMsQ0FBQyxPQUFPLEdBQUcsK0JBQStCO0lBQ2pFLE9BQU8sSUFBSSxtQkFBVyxDQUFDO1FBQ3JCLEdBQUcsRUFBRSx3QkFBd0IsQ0FBQyxTQUFTO1FBQ3ZDLE9BQU87S0FDUixDQUFDLENBQUE7QUFDSixDQUFDO0FBSUQsU0FBZ0IsVUFBVSxDQUFDLE1BQXlDLEVBQUUsTUFBaUM7SUFDckcsSUFBSSxPQUFPLEdBQUcsa0JBQWtCLENBQUE7SUFDaEMsSUFBSSxPQUFPLEdBQTZCLEVBQUUsQ0FBQTtJQUMxQyxJQUFHLE9BQU8sTUFBTSxLQUFLLFFBQVEsRUFBRSxDQUFDO1FBQzlCLE9BQU8sR0FBRyxNQUFNLENBQUE7SUFDbEIsQ0FBQztJQUNELElBQUcsTUFBTSxLQUFLLFNBQVMsRUFBRSxDQUFDO1FBQ3hCLE9BQU8sR0FBRyxNQUFNLENBQUE7SUFDbEIsQ0FBQztJQUNELE9BQU8sSUFBSSxtQkFBVyxDQUFDO1FBQ3JCLEdBQUcsRUFBRSx3QkFBd0IsQ0FBQyxVQUFVO1FBQ3hDLE9BQU87UUFDUCxPQUFPLEVBQUU7WUFDUCxPQUFPO1NBQ1I7S0FDRixDQUFDLENBQUE7QUFDSixDQUFDIn0=